import styled from 'styled-components';

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
`;

export const Section = styled.section`
  padding: 12px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  color: #262626;
  overflow-wrap: anywhere;
`;

export const Concept = styled.span`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
`;

export const Secondary = styled.span`
  font-size: 12px;
  color: #8c8c8c;
`;
